import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocumentRowToolbar from "./document-row-toolbar.vue";
import DocumentComments from "./document-comments.vue";
import { mapActions, mapGetters } from "vuex";
import { openFileDialog } from "@Shared/@Utils/utils";
import DocumentPreviewModal from "@Shared/components/document-previewer/document-preview-modal";
import { CURRENT_USER_DETAILS } from "@Client/@Modules/main/store/account/account-getters";
import { DOWNLOAD_DOCUMENT, SEND_DOCUMENT_COMMENT } from "../../store/document-actions";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentRow",
  components: {
    DocumentRowToolbar,
    DocumentComments,
    DocumentPreviewModal
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    document: {
      type: Object,
      required: true
    },
    comments: {
      type: Object,
      required: true
    },
    completed: {
      type: Boolean,
      default: false
    },
    uploadedBy: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showComments: false,
      downloadingDocument: false,
      loadingPreview: false,
      previewDocumentUrl: ""
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_USER_DETAILS])), {}, {
    documentId() {
      return this.document.documentId;
    },
    isUploadedByCoApplicant() {
      return this.CURRENT_USER_DETAILS.username !== this.uploadedBy && this.document.metadata && this.document.metadata.coApplicant === this.uploadedBy;
    },
    documentRequestId() {
      return this.document.documentRequestId;
    },
    isSample() {
      return this.document.isSample;
    },
    fileName() {
      return this.document.fileName;
    },
    createdAt() {
      return this.document.createdAt;
    },
    classificationType() {
      return this.document.classificationType;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentStore", [DOWNLOAD_DOCUMENT, SEND_DOCUMENT_COMMENT])), {}, {
    toggleComments(value) {
      this.showComments = value != null ? value : !this.showComments;
    },
    async handleDownloadDocument() {
      this.downloadingDocument = true;
      const {
        url
      } = await this.DOWNLOAD_DOCUMENT({
        fileName: this.fileName,
        documentId: this.documentId,
        applicationId: this.applicationId
      });
      openFileDialog(url, this.fileName);
      this.downloadingDocument = false;
    },
    showPreviewDocumentModal() {
      this.$refs.previewDocumentModal.$showModal();
    },
    async handlePreviewClick() {
      if (!this.isUploadedByCoApplicant) {
        this.loadingPreview = true;
        const {
          url
        } = await this.DOWNLOAD_DOCUMENT({
          fileName: this.fileName,
          documentId: this.documentId,
          applicationId: this.applicationId
        });
        this.previewDocumentUrl = url;
        this.showPreviewDocumentModal();
        this.loadingPreview = false;
      }
    },
    async handleCommentSubmit({
      comment
    }) {
      await this.SEND_DOCUMENT_COMMENT({
        applicationId: this.applicationId,
        documentId: this.documentId,
        comment,
        senderDetails: this.CURRENT_USER_DETAILS
      });
    },
    handlePreviewDocumentModalHide() {
      this.previewDocumentUrl = "";
    }
  })
});